import { render, staticRenderFns } from "./ClientBulkActions.vue?vue&type=template&id=59476bd2&scoped=true&"
import script from "./ClientBulkActions.vue?vue&type=script&lang=js&"
export * from "./ClientBulkActions.vue?vue&type=script&lang=js&"
import style0 from "./ClientBulkActions.vue?vue&type=style&index=0&id=59476bd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59476bd2",
  null
  
)

export default component.exports